
    import I18n from '@canvas/i18n/i18nObj';
    
      import 'translations/upload_drop_zone';
      import 'translations/_core';
    
    import 'translations/_core_en';

    export default I18n.scoped('upload_drop_zone');
  